<a class="skip-link" href="#main-content">Skip to main content</a>
<div class="sr-only" role="status">{{ routeAnnouncement() }}</div>
<router-outlet />
<app-cookie-banner
  [visible]="cookieBannerVisible()"
  [policyVisible]="cookiePolicyVisible()"
  (accepted)="onCookieAccept()"
  (declined)="onCookieDecline()"
  (policyOpened)="onCookiePolicyOpen()"
  (policyClosed)="onCookiePolicyClose()"
/>
<app-terms-and-conditions />
<kirigami-toaster />
